import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

/** Une réponse toute faite : un texte enregistré qu'on insère dans un texto.
 * Partagée par l'entreprise ; seuls les gestionnaires l'écrivent. */
export interface ReponseRapide {
  id: number
  title: string
  text: string
  updated_at: string
}

export const TEXTE_MAX = 1600
export const TITRE_MAX = 80

const CLE = ['quick-replies']

/** Les réponses de l'entreprise, par titre. */
export function useReponsesRapides(enabled = true) {
  return useQuery({
    queryKey: CLE,
    queryFn: async () => {
      const { data } = await api.get<ReponseRapide[]>('/api/quick-replies/')
      return data
    },
    enabled,
    staleTime: 60_000,
  })
}

export function useCreerReponse() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (corps: { title: string; text: string }) => {
      const { data } = await api.post<ReponseRapide>('/api/quick-replies/', corps)
      return data
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: CLE }),
  })
}

export function useModifierReponse() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, ...corps }: { id: number; title?: string; text?: string }) => {
      const { data } = await api.patch<ReponseRapide>(`/api/quick-replies/${id}/`, corps)
      return data
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: CLE }),
  })
}

export function useSupprimerReponse() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: number) => {
      await api.delete(`/api/quick-replies/${id}/`)
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: CLE }),
  })
}
